// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "reactPlayerPreview" + "." + "6ee19747144d81e2" + ".js";
};